import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Euro_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.17379 14C9.05994 14.644 9 15.3125 9 16C9 16.6875 9.05994 17.356 9.17379 18H18C18.5523 18 19 18.4477 19 19C19 19.5523 18.5523 20 18 20H9.72618C11.0939 23.5733 14.2336 26 17.762 26C19.8562 26 21.7919 25.1603 23.3162 23.7319C23.7192 23.3542 24.352 23.3748 24.7297 23.7778C25.1073 24.1807 25.0868 24.8136 24.6838 25.1912C22.825 26.9331 20.4118 28 17.762 28C13.006 28 9.07929 24.6113 7.61523 20H5C4.44772 20 4 19.5523 4 19C4 18.4477 4.44772 18 5 18H7.15001C7.05128 17.3479 7 16.6795 7 16C7 15.3205 7.05128 14.6521 7.15001 14H5C4.44772 14 4 13.5523 4 13C4 12.4477 4.44772 12 5 12H7.61523C9.07929 7.38871 13.006 4 17.762 4C20.4118 4 22.825 5.06694 24.6838 6.80878C25.0868 7.18642 25.1073 7.81925 24.7297 8.22225C24.352 8.62524 23.7192 8.64579 23.3162 8.26814C21.7919 6.83968 19.8562 6 17.762 6C14.2336 6 11.0939 8.42674 9.72618 12H18C18.5523 12 19 12.4477 19 13C19 13.5523 18.5523 14 18 14H9.17379Z"
            />
        </SvgStyled>
    );
};

export default Euro_lg;
